import {
    EuiBadge,
    EuiButton,
    EuiEmptyPrompt,
    EuiInMemoryTable,
    EuiPanel,
    EuiSpacer,
    EuiText,
    formatDate
} from "@elastic/eui";
import {observer} from "mobx-react-lite";
import React, {Fragment, useContext, useEffect, useRef, useState} from "react";
import {Store} from "../../../app/stores/store-root";
import "@elastic/eui/dist/eui_theme_light.css";
import {Order} from "../../../app/models/order";
import {NavLink, useHistory} from "react-router-dom";
import {SearchFilterConfig} from "@elastic/eui/src/components/search_bar/search_filters";
import {EuiSearchBarProps} from "@elastic/eui/src/components/search_bar/search_bar";
import Invoice from "../receive-agent/invoice";
import MessageModal from "../../../app/common/message-modal";
import { useReactToPrint } from 'react-to-print';


type dataProps = {
    items: Order[];
};




export const CashierAgentOrdersList = ({items}: dataProps) => {
    const [error, setError] = useState(undefined);
    const [selection, setSelection] = useState([]);
    const [searchResults, setSearchResults]=useState<Order[]>([]);
    const history = useHistory();
    const store = useContext(Store);
    const selectionValue = {
        selectable: (order: any) => true,
        initialSelected: selection,
        onSelectionChange: (selection: any) => {
            setSelection(selection);
            console.log(selection);
        },
    };


    const fields = [

        {
            field: 'Reference',
            name: 'Reference',
            sortable: true,
            truncateText: true,
            render: (reference: string) => {
                return (<NavLink to={`orders/edit/${reference}`}>
                    {reference}
                </NavLink>)
            }
        },
        {
            field: 'SendingAmount',
            name: 'Sending Amount',
            truncateText: true,
            render: (value: any, item: Order) => {
                return `${item.SendingCurrencySymbol} ${value}`
            }

        },
        {
            field: 'ReceivingAmount',
            name: 'Receiving',
            truncateText: true,
            render: (value: any, item: Order) => {
                return `${item.ReceivingCurrencySymbol}${value}`
            }

        },
        {
            field: 'ExchangeRate',
            name: 'Rate',
            truncateText: true,
        },
        {
            field: 'CreatedByName',
            name: 'Created By',
            truncateText: true,
        },
        {
            field: 'DeliveryType',
            name: 'Trasnfer Type',
            truncateText: true,
            render: (type: any) => {
                return (type === "0") ? "Bank" : "Cash"
            }
        },
        {
            field: 'DeliveryOffice',
            name: 'Branch',
            truncateText: true,
            render: (branch: string) => {
                if (!branch)
                    return 'Bank Transfer'
                else
                    return branch
            }
        }
        ,
        {
            field: 'RemitterName',
            name: 'Remitter',
            truncateText: true,

        },
        {
            field: 'BeneficiaryName',
            name: 'Beneficiary',
            truncateText: true,

        },
        {
            field: 'CreatedAt',
            name: 'Created At',
            sortable: true,

        }
    ]

    const searchSettings: EuiSearchBarProps = {
        box: {
            incremental: true,
            schema: true,
            placeholder: ''
        },
        onChange: (args: any) => {
            if(args.queryText.length>=5) {
                const returned: Order[] = store.Orders.searchReadyOrders(args.queryText);
                setSearchResults(returned)
                console.log('Search Results  ', returned);
            }
        }
    }


    const [message, setMessage] = useState(
        <EuiEmptyPrompt
            iconType="editorStrike"
            title={<h2>Search using order reference or beneficiary telephone number</h2>}
            body={
                <Fragment>
                    <p>
                    </p>
                </Fragment>
            }
        />
    );


    const openInvoice = (order: Order) => {
        store.Orders.SetCurrentOrder(order);
        history.push('/invoice');
    }

    const onCancel = (order: Order) => {
        order.CancelledAt = new Date();
        order.CancelledByName = `${store.Users.Name} ${store.Users.UserName}`;
        order.CancelledBySub = store.Users.Sub;
        order.CancelledByUserName = store.Users.UserName;

        //Todo : Add Are you sure you want to cancel?
        store.Orders.CancelOrder(order)
            .then(() => {
                const message = `Order ${order.Reference} has been cancelled successfully.`
                store.Modal.openModal(
                    <MessageModal message={message} success={true}/>
                );
                history.push("/");
            })
            .catch((e) => {
                store.Modal.closeModal();
                const message = `Unable to cancel order ${order.Reference}. The following error message returned from the server. ${e.response.data.error}.`
                store.Modal.openModal(
                    <MessageModal message={message} success={false}/>
                );
                console.log(e.response.data);
            })
            .finally(() => {
                console.log('Done OnCancel function')
            });
    };

    const cancelAction: any = {
        name: "Reject Order",
        description: "Reject Order",
        icon: "cross",
        type: "icon",
        color: "danger",
        onClick: onCancel
    }

    const openSupportTicket = (order: any) => {
        history.push(`/tickets/create/${order.Reference}`)
    }
    const supportAction: any =
        {
            name: 'Support',
            description: 'Ask Admin for help',
            icon: 'help',
            type: 'icon',
            onClick: openSupportTicket,
        }


    const actions = [
        cancelAction, supportAction
    ];


    const columns = [

        {
        field: 'Reference',
        name: 'Reference',
        sortable: true,
        truncateText: true,
        render: (reference: string) => {
            return (<NavLink to={`orders/edit/${reference}`}>
                {reference}
            </NavLink>)
        }
    },
        {
            field: 'SendingAmount',
            name: 'Sending Amount',
            truncateText: true,
            render: (value: any, item: Order) => {
                return `${item.SendingCurrencySymbol} ${value}`
            }

        },
        {
            field: 'ReceivingAmount',
            name: 'Receiving',
            truncateText: true,
            render: (value: any, item: Order) => {
                return `${item.ReceivingCurrencySymbol}${value}`
            }

        },
        {
            field: 'ExchangeRate',
            name: 'Rate',
            truncateText: true,
        },
        {
            field: 'DeliveryType',
            name: 'Trasnfer Type',
            truncateText: true,
            render: (type: any) => {
                return (type === "0") ? "Bank" : "Cash"
            }
        },
        {
            field: 'Status',
            name: 'Status',
            truncateText: true,
            render: (type: any) => {
                if (type === 0)
                    return <EuiBadge color="warning">Pending</EuiBadge>
                if (type === 1)
                    return <EuiBadge color="secondary">Ready</EuiBadge>
                if (type === 2)
                    return <EuiBadge color="danger">Ready</EuiBadge>
                if (type === 5)
                    return <EuiBadge color="#FCF7BC">In Progress</EuiBadge>

            }
        },

        {
            field: 'DeliveryOffice',
            name: 'Branch',
            truncateText: true,
            sortable: true,
            render: (branch: string) => {
                if (!branch)
                    return 'Bank Transfer'
                else
                    return branch
            }
        }
        ,
        {
            field: 'RemitterName',
            name: 'Remitter',

            sortable: true,

        },
        {
            field: 'BeneficiaryName',
            name: 'Beneficiary',
            sortable: true,

        },
        {
            field: 'BeneficiaryPhone',
            name: 'Phone',

            sortable: true,

        },

        {
            field: 'PaidAt',
            name: 'Paid At',
            sortable: true,
            render: (date: any) => formatDate(date, "dobLong"),

        },
        {
            name: "Actions",
            actions,
        },
    ]

    /*  const columns = [
         {
             field: "Reference",
             name: "Reference",
             sortable: true,
             truncateText: true,
         },
         {
             field: "Remitter",
             name: "Remitter",
             sortable: true,
             truncateText: true,
         },
         {
             field: "Beneficiary",
             name: "Beneficiary",
             sortable: true,
             truncateText: true,
         },
         {
             field: "SendingAmount",
             name: "Sends",
             sortable: true,
             truncateText: true,
         },
         {
             field: "ReceivingAmount",
             name: "Receives",
             sortable: true,
             truncateText: true,
         },
         {
             field: "CreatedAt",
             name: "Created At",
             render: (date: any) => formatDate(date, "dobLong"),
             sortable: true,
         },
         {
             name: "Actions",
             actions,
         },
     ];
 */


    return (
        <Fragment >
            <EuiPanel hasShadow={true} paddingSize={'l'}>
                <EuiText>
                    <h3>Orders Ready For Collection & In Progress</h3>
                    <p>
                        This section you can search all money transfer orders when provided with reference code provided by customer.
                    </p>
                </EuiText>
                <EuiSpacer size={"xxl"}/>
                <EuiInMemoryTable
                    items={searchResults}
                    itemId="Reference"
                    columns={columns}
                    pagination={true}
                    selection={selectionValue}
                    isSelectable={true}
                    search={searchSettings}
                    hasActions={true}
                    sorting={true}
                    message={message}
                />
            </EuiPanel>

        </Fragment>

    );
};

export default observer(CashierAgentOrdersList);
